import { BaseFiltroPagDTO } from "./base-dto";

export const PRESCRIPTIONS_MONTH_PDFS_TYPE ='PDFS_PRESCRICOES_MES';

export class ProcExecFiltrosParmDTO extends BaseFiltroPagDTO {
  tipo: string;
  ultimasHoras: number = 240

}